export default __webpack_public_path__ + "static/media/background.8b88237d.jpg";